import { makeStyles } from '@/styles/theme/tss-react';
import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

export const useStyles = makeStyles<Props>()(
  ({ brandColors, typography: { pxToRem } }, props) => ({
    root: {
      '&&': {
        color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
        padding: 0,
      },
      '&.Mui-disabled': {
        opacity: 0.3,
      },
      '&:focus-within': {
        outline: `${pxToRem(1.5)} solid ${brandColors.tintsChargeBlue50}`,
        borderRadius: pxToRem(4),
      },
    },
  })
);
